import React from 'react';
import comimg from '../exp_logo/exp-common.png';

export default function Education() {
  return (
    <>
    <div className="subheadings education">
        <h1>Education</h1>
        {/* <div className="search-education">
            <input type="text" className="form-control searchsubheadings searcheducationinput" placeholder="Search..."/>
        </div> */}
        <div className="education-tilldate">
          <div className="card education-card exp-a">
            <div className="card-body education-card-body">
              <div className="common-img">
                <img src={comimg} alt='common-img' className='exp-common-image'/>
              </div>
              <div className="card-desc education-card-desc">
                  <h5 className="card-title education-card-title">Bachelor in Computer Engineering</h5>
                  <div className="education-place">Rajendra Mane College of Engineering & Technology</div>
                  <div className="card-dur education-dur">
                      Aug 2019 - May 2022 
                  </div>
              </div>
            </div>
          </div>
          <div className="card-pointer">
            <i className="fa-regular fa-circle-dot"></i>
          </div>
          <div className="centerline"></div>
        </div>

        <div className="education-tilldate second">
          <div className="card education-card exp-a">
            <div className="card-body education-card-body">
              <div className="common-img">
                <img src={comimg} alt='common-img' className='exp-common-image'/>
              </div>
              <div className="card-desc education-card-desc">
                  <h5 className="card-title education-card-title">Diploma in Computer Engineering</h5>
                  <div className="education-place">Government Polytechnic Ratnagiri</div>
                  <div className="card-dur education-dur">
                      Sept 2016 - June 2019 
                  </div>
              </div>
            </div>
          </div>
          <div className="card-pointer">
            <i className="fa-regular fa-circle-dot"></i>
          </div>
          <div className="centerline"></div>
        </div>
    </div>
    </>
  )
}
